import React from 'react'
import { Navigate, Route, Routes} from 'react-router-dom'

import {
  NonCaptablesValidationForm,
  NonCaptablesValidationContext,
  APPS_COMBOS_IDS,
  ORDER_COMBOS_IDS,
  NonCaptablesValidationCertificateForm,
} from '../../../features/non-captables-validation'
import { useCombos } from '../../../features/combos/hooks'
import { NonCaptablesValidationDashboardPage } from './dashboard'

const NonCaptablesValidationPageBare = () => {
  useCombos(APPS_COMBOS_IDS, ORDER_COMBOS_IDS)
  return (
    <Routes>
      <Route
        path="/non-captables-validation"
        element={<NonCaptablesValidationDashboardPage />}
      />
      <Route path="/non-captables-validation/:appId" element={<NonCaptablesValidationForm />} />
      <Route
        path="/non-captables-validation/:appId/:certificateType"
        element={<NonCaptablesValidationCertificateForm />}
      />
      <Route path="*" element={<Navigate to="/non-captables-validation" />} />
    </Routes>
  )
}

export const NonCaptablesValidationPage = (props) => {
  return (
    <NonCaptablesValidationContext>
      <NonCaptablesValidationPageBare {...props} />
    </NonCaptablesValidationContext>
  )
}
